<template>
  <b-card no-body v-if="description || attributes.length > 0 || attachments.length > 0">
    <b-tabs card v-model="tabIndex">
      <b-tab  v-if="description" title="Opis" >
        <div class="product-description" v-html="description"></div>
      </b-tab>
      <b-tab v-if="attributes.length > 0" title="Specyfikacja" >
        <ul>
          <li v-for="attr in attributes">
            <label class="attr-name">{{attr.AttributeProperty.Name}}</label>
            <label class="attr-value">{{attr.Value}}</label>
          </li>
        </ul>

      </b-tab>
      <b-tab v-if="attachments.length > 0" title="Załączniki" >
        <Attachments :files="attachments" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

 <script>
 import Attachments from './Attachments.vue';
 import {BCard} from "bootstrap-vue/esm/components/card/card";
 import {BTabs} from "bootstrap-vue/esm/components/tabs/tabs";
 import {BTab} from "bootstrap-vue/esm/components/tabs/tab";
 export default {
   components: {
       BTab,
       BTabs,
       BCard,
       Attachments},
   props: ["productId", "attachments", "attributes"],
   data() {
     return {
       tabIndex: 0,
       description: "&nbps;",
     }
   },
   async beforeMount() {
     let description = await this.$store.dispatch("search/description", this.productId);
     this.description = description.description;
     this.tabIndex = 0;
   }

 }
 </script>



// WEBPACK FOOTER //
// src/components/products/src/productPage/elements/Tabs.vue